import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Content from "./components/layout/Content";
import { globalStyles } from "./styles/globalStyleTheming";
import { CssBaseline, CircularProgress } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router";
import LoginPage from "./components/layout/LoginPage";
import paths from "./routes";

const style = {
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
  },
} as const;

function App() {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();
  const isProspectsPage = location.pathname.startsWith(
    paths.prospects.base.pattern,
  );

  const appContainerStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    ...(isProspectsPage && {
      width: "fit-content",
      minWidth: "100vw",
    }),
  } as const;

  if (isLoading) {
    return (
      <ThemeProvider theme={globalStyles}>
        <CssBaseline />
        <Box sx={style.loadingContainer}>
          <CircularProgress />
        </Box>
      </ThemeProvider>
    );
  }

  if (isAuthenticated) {
    return (
      <ThemeProvider theme={globalStyles}>
        <CssBaseline />
        <Box data-testid="new-admin-container" sx={appContainerStyle}>
          <Header />
          <Content />
          <Footer />
        </Box>
      </ThemeProvider>
    );
  }

  return <LoginPage />;
}
export default App;
